function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

window.addEventListener("load", () => {
  const form = document.querySelector(".product-single__form");
  if (!form) {
    return;
  }
  const btn = form.querySelector(".addtocart.btn.btn--full.add-to-cart.bold_clone");

  const observer = new MutationObserver(() => {
    const isInvalid = form.querySelectorAll(".bold_option_error").length > 0;
    if (isInvalid && !document.getElementById("form-error")) {
      const p = document.createElement("p");
      p.setAttribute("id", "form-error");
      p.textContent = "Please complete the missing fields above to add to cart";
      p.style.color = "red";
      insertAfter(document.querySelector(".product__quantity.product-quantity-embedded-section"), p);
    }
  });
  observer.observe(form, { childList:true, subtree: true });
});
